module.exports = __webpack_public_path__ + "static/handmade-hobbies2-7bac36246286344d573fb74dd54c6f05.png";